// /components/share/ShareBadgeAsPost.jsx
import React from 'react';
import { useComposer } from '../composer/useComposer';

export default function ShareBadgeAsPost({ badge }) {
  const { openComposer } = useComposer();

  const onClick = () => {
    openComposer({
      text: `I just earned the **${badge?.name}** badge on JG Trailblazer! 🏅`,
      media: badge?.iconUrl || '', // optional; can omit to post text only
    });
  };

  return (
    <button
      onClick={onClick}
      title="Share as post"
      style={{
        border: '1px solid rgba(148,163,184,.4)',
        borderRadius: 999,
        padding: '6px 12px',
        background: 'transparent',
        cursor: 'pointer',
        fontWeight: 600,
        fontSize: 12,
      }}
      aria-label="Share badge as a JG post"
    >
      Share as Post
    </button>
  );
}
